import { createTermTagManager } from '../../utils/createTermTagManager';

export const loggiaTagManager = createTermTagManager({
  jsonQueryKey: 'loggia',
  label: 'Есть лоджия',
  id: 'loggia',
});
